import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import * as dataFormat from "./UsersDataFormatters";
import actions from "../../../actions/usersListActions";
import axios from "axios";
import swal from "sweetalert";
import {
  GET_USER,
  API_TIMEOUT,
  GET_BANTUAN_TAHUN_KATEGORI,
  GET_BANTUAN_TAHUN_AMBIL,
  GET_BANTUAN,
  DELETE_BANTUAN,
  GET_BANTUAN_TAHUN,
} from "../../../utils";

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledButtonDropdown,
  DropdownToggle,
  Col,
  Row,
  Badge,
  UncontrolledTooltip,
  Input,
  Label,
  Spinner,
} from "reactstrap";

import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";

import Widget from "../../Widget/Widget";

import s from "../Users.module.scss";
import { useDispatch } from "react-redux";
import { numberWithCommas } from "../../../utils/func";

const { SearchBar } = Search;

const PenerimaListTable = (props) => {
  const { rows, dispatch, loading, idToDelete, modalOpen } = props;
  const [rowsTable, setRowsTable] = useState([]);
  const [currentUser, setCurrentUser] = useState();
  const [rowsKu, setRowsKu] = useState([]);
  const [idHapus, setIdHapus] = useState();
  const [simpleDropdownValue, setSimpleDropdownValue] = useState("");
  const currentYear = new Date().getFullYear();
  const listTahun = Array.from(
    { length: currentYear - 2018 + 1 },
    (_, i) => ({ tahun: 2018 + i })
  ).reverse();
  const [simpleDropdownValue2, setSimpleDropdownValue2] = useState(
    String(currentYear)
  );
  const [bantuan, setBantuan] = useState([]);
  const [currentBantuan, setCurrentBantuan] = useState("");
  const [tahun, setTahun] = useState(String(currentYear));
  const [jumlahPenerimaBantuan, setJumlahPenerimaBantuan] = useState(0);
  const [totalDana, setTotalDana] = useState(0);
  const [totalDesa, setTotalDesa] = useState(0);

  const [modalDelete, setModalDelete] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(true);

  const dispatchKu = useDispatch();

  const changeSelectDropdownSimple = (e) => {
    const select = e.target.value;
    setSimpleDropdownValue(select);
    setCurrentBantuan(select);
  };
  const changeSelectDropdownSimple2 = (e) => {
    const select = e.currentTarget.textContent.trim();
    setSimpleDropdownValue2(select);
    setTahun(select);
    ambilBantuan(select);
  };

  useEffect(() => {
    if (!currentUser) {
      const currentUser = JSON.parse(localStorage.getItem("user"));
      setCurrentUser(currentUser);
    }
  }, []);

  useEffect(() => {
    if (currentUser && tahun) {
      ambilBantuan(tahun);
    }
  }, [currentUser]);

  useEffect(() => {
    if (currentBantuan && tahun) {
      ambilDataBantuanKategori(currentBantuan, tahun);
    }
  }, [currentBantuan, tahun]);

  const ambilBantuan = (tahun) => {
    setIsLoadingData(true);
    axios({
      method: "post",
      url: GET_BANTUAN_TAHUN,
      timeout: API_TIMEOUT,
      data: {
        tahun: tahun,
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL

          const data = response.data.data || [];
          let dataFilter = [];
          if (data.length > 0) {
            if (currentUser.peran == "admin") {
              dataFilter = data.filter((item) => {
                return item.dinas == currentUser.dinas;
              });
            } else {
              dataFilter = data;
            }
            if (dataFilter.length > 0) {
              setSimpleDropdownValue(dataFilter[0].bantuan);
              setCurrentBantuan(dataFilter[0].bantuan);
              setBantuan(dataFilter);
            } else {
              setSimpleDropdownValue("");
              setCurrentBantuan("");
              setBantuan(dataFilter);
              setRowsKu([]);
              setJumlahPenerimaBantuan(0);
              setTotalDana(0);
              setTotalDesa(0);
            }
          } else {
            setSimpleDropdownValue("");
            setCurrentBantuan("");
            setBantuan(dataFilter);
            setRowsKu([]);
            setJumlahPenerimaBantuan(0);
            setTotalDana(0);
            setTotalDesa(0);
          }
          //setFirstTable(response.data.data);
        }
      })
      .catch((error) => {
        alert(error?.message || "Gagal mengambil data");
      })
      .finally(() => setIsLoadingData(false));
  };

  const ambilDataBantuanKategori = (bantuan, tahun) => {
    if (!bantuan || !tahun) {
      swal("Info", "Jenis bantuan dan tahun pelaksanaan perlu dipilih", "info");
      return;
    }
    setIsLoadingData(true);
    axios({
      method: "post",
      url: GET_BANTUAN_TAHUN_KATEGORI,
      timeout: API_TIMEOUT,
      data: {
        bantuan: bantuan,
        tahun: tahun,
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL

          const data = response.data.data || [];
          setJumlahPenerimaBantuan(data.length);
          const uniqueDesa = new Set(data.map((item) => item.desa).filter(Boolean));
          setTotalDesa(uniqueDesa.size);
          const sumDana = data.reduce((acc, item) => {
            const raw = parseFloat(String(item.nilaiUang || 0).replace(/[^\d.-]/g, "")) || 0;
            return acc + raw;
          }, 0);
          setTotalDana(sumDana);
          data.map((item, index) => {
            data[index].nilaiUang = numberWithCommas(item.nilaiUang);
            data[index].umur = hitungUmur(item.dob);
          });

          setRowsKu(
            data.map((item, index) => ({
              ...item,
              nomor: index + 1,
            }))
          );
        }
      })
      .catch((error) => {
        alert(error?.message || "Gagal mengambil data");
      })
      .finally(() => setIsLoadingData(false));
  };

  const hitungUmur = (dob) => {
    const startDate = new Date(dob);
    const today = new Date();

    const yearDiff = today.getFullYear() - startDate.getFullYear();
    const monthDiff = today.getMonth() - startDate.getMonth();
    const totalMonthDiff = Math.ceil((yearDiff * 12 + monthDiff) / 12) + " thn";
    return totalMonthDiff;
  };

  const handleDelete = () => {
    axios({
      method: "delete",
      url: DELETE_BANTUAN + idHapus,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL
          swal("Sukses", "Data Penerima berhasil dihapus", "success");
          const idToDelete = idHapus;
          const filteredArray = rowsKu
            .filter((obj) => obj.id !== idToDelete)
            .map((item, index) => ({ ...item, nomor: index + 1 }));
          const uniqueDesa = new Set(filteredArray.map((item) => item.desa).filter(Boolean));
          const sumDana = filteredArray.reduce((acc, item) => {
            const raw = parseFloat(String(item.nilaiUang || 0).replace(/[^\d.-]/g, "")) || 0;
            return acc + raw;
          }, 0);
          setRowsKu(filteredArray);
          setJumlahPenerimaBantuan(filteredArray.length);
          setTotalDesa(uniqueDesa.size);
          setTotalDana(sumDana);
          setModalDelete(false);
        }
      })
      .catch((error) => {
        // ERROR
        alert(error);
      });
  };
  const openModal = (cell) => {
    const id = cell;

    setIdHapus(id);
    setModalDelete(true);
  };
  const closeModal = () => {
    setModalDelete(false);
  };
  const actionFormatter = (cell) => {
    return (
      <div className={`d-flex justify-content-between`}>
        <Button
          className={s.controlBtn}
          color="info"
          size="xs"
          onClick={() => props.dispatch(push(`/admin/penerima/${cell}`))}
        >
          View
        </Button>
        <Button
          className={`${s.controlBtn} mx-2`}
          color="success"
          size="xs"
          onClick={() => props.dispatch(push(`/admin/penerima/${cell}/edit`))}
        >
          Edit
        </Button>
        <Button
          className={s.controlBtn}
          color="danger"
          size="xs"
          onClick={() => {
            openModal(cell);
          }}
        >
          Delete
        </Button>
      </div>
    );
  };

  useEffect(() => {
    dispatch(actions.doFetch({}));
  }, []);

  const columns = [
    {
      dataField: "nomor",
      text: "No.",
      sort: true,
      headerStyle: { width: "60px", minWidth: "60px", textAlign: "center" },
      style: { width: "60px", minWidth: "60px" },
    },
    {
      dataField: "nama",
      sort: true,
      text: "Nama",
      headerStyle: { width: "180px", minWidth: "120px" },
      style: { width: "180px", minWidth: "120px" },
      formatter: (cell) => (
        <span style={{ wordBreak: "break-word", display: "block" }}>
          {cell}
        </span>
      ),
    },
    {
      dataField: "kelompok",
      sort: true,
      text: "Kelompok",
      headerStyle: { width: "120px", minWidth: "100px" },
      style: { width: "120px", minWidth: "100px" },
    },
    {
      dataField: "bantuan",
      sort: true,
      text: "Bantuan",
      headerStyle: { width: "200px", minWidth: "120px" },
      style: { width: "200px", minWidth: "120px" },
      formatter: (cell) => (
        <span style={{ wordBreak: "break-word", display: "block" }}>
          {cell}
        </span>
      ),
    },
    {
      dataField: "nilaiUang",
      sort: true,
      text: "Nilai Uang",
      headerStyle: { width: "120px", minWidth: "120px" },
      style: { width: "120px", minWidth: "120px" },
    },
    {
      dataField: "desa",
      sort: true,
      text: "Desa",
      headerStyle: { width: "140px", minWidth: "120px" },
      style: { width: "140px", minWidth: "120px" },
    },
    {
      dataField: "id",
      formatter: actionFormatter,
      text: "Actions",
      headerStyle: { width: "180px", minWidth: "180px" },
      style: { width: "180px", minWidth: "180px" },
    },
  ];

  return (
    <div className={s.jenisBantuanMinimal}>
      <Widget className={`widget-p-md ${s.dataLoadingWrap} ${isLoadingData ? s.loading : ""}`}>
        {isLoadingData && (
          <div className={s.dataLoadingOverlay}>
            <Spinner color="primary" />
            <span className={s.dataLoadingText}>Memuat data...</span>
          </div>
        )}
        <Row className="mb-3">
          <Col xs={12}>
            <div className={`d-flex flex-wrap align-items-center ${s.summaryChipsWrap}`}>
              <span className={s.summaryChip} id="chip-penerima">
                <span className={s.summaryChipLabel}>Jumlah Penerima</span>
                <Badge color="danger" pill className={s.summaryChipValue}>
                  {jumlahPenerimaBantuan}
                </Badge>
              </span>
              <UncontrolledTooltip placement="top" target="chip-penerima">
                Total penerima bantuan berdasarkan bantuan dan tahun yang dipilih
              </UncontrolledTooltip>

              <span className={s.summaryChip} id="chip-total-dana-penerima">
                <span className={s.summaryChipLabel}>Total Dana</span>
                <Badge color="success" pill className={s.summaryChipValue}>
                  Rp {numberWithCommas(totalDana)}
                </Badge>
              </span>
              <UncontrolledTooltip placement="top" target="chip-total-dana-penerima">
                Total nilai uang bantuan yang diterima
              </UncontrolledTooltip>

              <span className={s.summaryChip} id="chip-sebaran-desa">
                <span className={s.summaryChipLabel}>Sebaran Desa</span>
                <Badge color="primary" pill className={s.summaryChipValue}>
                  {totalDesa}
                </Badge>
              </span>
              <UncontrolledTooltip placement="top" target="chip-sebaran-desa">
                Jumlah desa asal penerima bantuan
              </UncontrolledTooltip>
            </div>
          </Col>
        </Row>
        <Row className="align-items-end">
          <Col xs={12} sm={6} md={3} lg={2} className="mb-2 mb-md-0">
            <Label for="select-tahun-penerima" className="mb-1">
              Tahun
            </Label>
            <UncontrolledButtonDropdown className="d-block">
              <DropdownToggle caret color="primary" id="dropdown-tahun-penerima" block>
                {simpleDropdownValue2}
              </DropdownToggle>
              <UncontrolledTooltip placement="top" target="dropdown-tahun-penerima">
                Filter data berdasarkan tahun pelaksanaan
              </UncontrolledTooltip>
              <DropdownMenu>
                {listTahun &&
                  listTahun.map((item) => (
                    <DropdownItem
                      key={item.tahun}
                      onClick={changeSelectDropdownSimple2}
                    >
                      {item.tahun}
                    </DropdownItem>
                  ))}
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </Col>
          <Col xs={12} sm={6} md={6} lg={7} className={`mb-2 mb-md-0 ${s.selectBantuanWrap}`}>
            <Label for="select-bantuan-penerima" className="mb-1">
              Bantuan
            </Label>
            <Input
              id="select-bantuan-penerima"
              type="select"
              value={simpleDropdownValue}
              onChange={changeSelectDropdownSimple}
            >
              <option value="">Pilih Bantuan</option>
              {bantuan &&
                bantuan.map((item, index) => (
                  <option key={`${index}-${item.bantuan}`} value={item.bantuan}>
                    {item.bantuan}
                  </option>
                ))}
            </Input>
            <UncontrolledTooltip placement="top" target="select-bantuan-penerima">
              Filter data berdasarkan jenis bantuan
            </UncontrolledTooltip>
          </Col>
          <Col xs={12} sm={12} md={3} lg={3} className="mb-2 mb-md-0 d-flex align-items-end">
            <Button
              id="btn-tambah-penerima"
              color="success"
              className="btn w-100"
              onClick={() => dispatchKu(push(`/admin/penerima/new`))}
            >
              <i className="fa fa-plus mr-2" aria-hidden="true" />
              Tambah Penerima
            </Button>
            <UncontrolledTooltip placement="left" target="btn-tambah-penerima">
              Klik untuk menambah data penerima bantuan baru
            </UncontrolledTooltip>
          </Col>
        </Row>
        <ToolkitProvider columns={columns} data={rowsKu} keyField="id" search>
          {(props) => (
            <div className={s.jenisBantuanTableWrap}>
              <BootstrapTable
                bordered={false}
                classes="table-striped table-hover mt-4"
                pagination={paginationFactory()}
                {...props.baseProps}
              />
            </div>
          )}
        </ToolkitProvider>
      </Widget>
      <Modal size="sm" isOpen={modalDelete} toggle={() => closeModal()}>
        <ModalHeader toggle={() => closeModal()}>Konfirmasi hapus</ModalHeader>
        <ModalBody>
          apakah anda yakin akan menghapus data penerima bantuan ini?
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => closeModal()}>
            Cancel
          </Button>
          <Button color="primary" onClick={() => handleDelete()}>
            Delete
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

function mapStateToProps(store) {
  return {
    loading: store.users.list.loading,
    rows: store.users.list.rows,
    modalOpen: store.users.list.modalOpen,
    idToDelete: store.users.list.idToDelete,
  };
}

export default connect(mapStateToProps)(PenerimaListTable);
